export default __webpack_public_path__ + "static/media/selectedHomeLogo.d81d1aed.svg";